import React from 'react';
import ReactDOM from 'react-dom';
import { ua } from '../ua';
import { weappSDK } from "../sdk";
import history from "../history-plugin/history";
import moduleRouter from "../moduleRouter";
import { BrowserRouter as Router } from 'react-router-dom';
import { whiteList, whiteListSdk } from './whitelist';
import Content, { ALINK_LS_NAME } from './Content';
import { getSecondPathUrl } from '../open';


/**
 * TODO:
 * A标签链接跳转处理

  1. 添加全局事件监听链接点击跳转事件
  2. 处理旧地址中事项卡片打开
  3. 处理新地址中事项卡片打开
  4. 处理跨域地址打开拦截

  打开事项卡片

  1. 从地址中解析出模块标识和事项id
  2. 移动端处理事项单页地址打开
  3. Pc端处理事项卡片打开

*/

export function showCorsRouter(params: any) {
  const { rootPath } = params;
  const routerRef = React.createRef<any>();
  // url?: string, otherParams?: VideoProps

  const div = document.createElement('div');
  document.body.appendChild(div);

  function destroy() {
    ReactDOM.unmountComponentAtNode(div);
    if (div.parentNode) {
      div.parentNode.removeChild(div);
    }
  };

  const CorsRouter = window.weappUi?.CorsRouter;

  ReactDOM.render(
    <Router ref={routerRef}>
      <CorsRouter weId={`globalCorRouter`}
        rootPath={rootPath || '/'}
      />
    </Router>
  , div);
 
  return {
    routerRef,
    destroy,
  }
}


/**
 * 判断是否为相对路径
 * @param {string} href 需要判断的地址
 * @return {boolean}
 */
function isAbsoluteHref (href: string) {
  return /^https?/.test(href);
}

/**
 * 判断地址是否跨域
 * @param tHref 目标地址
 * @param oHref 源地址
 * @return {boolean}
 */
function isCorsOrigin (tHref: string, oHref: string = window.location.origin) {
  if (isAbsoluteHref(tHref)) {
    return tHref.indexOf(oHref) !== 0;
  }
}

function checkWhiteList (url: string) {
  let flag = false;
  let i = 0;
  while(!flag && i < whiteList.length) {
    let patt = whiteList[i];
    flag = url.indexOf(patt) !== -1;
    i ++;
  }

  const sdkWhiteList = whiteListSdk.whiteList 
  if (Array.isArray(sdkWhiteList) && sdkWhiteList.length) {
    let j = 0;
    while(!flag && j < sdkWhiteList.length) {
      let pattStr = sdkWhiteList[j];
      flag = url.indexOf(pattStr) !== -1;
      j ++;
    }
  }
  return flag;
}

function noRemind () {
  const noRemind = window.localStorage?.getItem(ALINK_LS_NAME);
  return noRemind === 'true';
}

function formatUrl (url: string) {
  let module = '';
  let id = '';
  let params = {};
  /**
   * TODO：处理旧模块事项卡片地址
   * eg:
   * https://www.eteams.cn/workflows/4540972865880120347/all/4571182754376473160/einfo
   * https://www.eteams.cn/redirectetinfo.html?module=task&id=8993046170280041266&tenantKey=t7akvdnf84
   * https://www.eteams.cn/task/etinfo/7453033716139787452?tenantKey=t7akvdnf84
   */
  /**
   * TODO: 处理新模块事项卡片地址
   * 
   */
  return { module, id, params };
}

function isSecurityHref ( href: string ) {
  // href.indexOf('#') === 0: 页面内锚点
  return typeof href === 'string' && href.trim() !== '' && href !== 'javascript:void(0)' && href.indexOf('#') !== 0;
}

// 对外抛出标签拦截事件,方便外部直接调用
export const ALinkIntercept = (href: string) => {
  // 屏蔽空链接 和 不满足超链接的链接
  if (!isSecurityHref(href)) return;
  // 处理域名白名单
  if (checkWhiteList(href)) {
    window.open(href);
    return;
  }
  // 设置"不再提醒"
  if (noRemind()) {
    window.open(href);
    return;
  }
  // 处理跨域地址
  if (isCorsOrigin(href)) {
    if (ua.device === 'PC' && window.weappUi?.Dialog?.confirm) {
      window.weappUi.Dialog.confirm({
        mask: true,
        content: <Content />,
        onOk: () => {
          window.open(href);
        },
      });
    } else if (ua.device !== 'pc' && window.weappUi?.MDialog?.prompt) {
      window.weappUi.MDialog.prompt({
        mask: true,
        message: <Content /> ,
        prompt: false,
        onOk: () => {
          window.open(href);
        }
      });
    } else {
      window.open(href);
    }
  } else {
    window.open(href);
  }
}

class ALink {

  constructor() {
    this.addListener();
  }

  addListener = () => {
    document.addEventListener('click', this.handleLinkClick, true);
  }

  removeListener = () => {
    document.removeEventListener('click', this.handleLinkClick, true);
  }

  handleLinkClick = (e: MouseEvent) => {
    const target = e.target as any;
    if (target && target.tagName === 'A' && target.href) {
      const aTarget = target as HTMLLinkElement;
      const href = aTarget.href;
      // 屏蔽空链接 和 带click事件的链接
      if (!href || aTarget.onclick) return;

      // 屏蔽编辑状态下的编辑器组件的链接（不需要触发公共的超链接拦截）
      const editorEl = target.closest('.ProseMirror');
      if (editorEl && editorEl.getAttribute('contenteditable') === 'true') return;

       // 匹配对应href地址内容  getSecondPathUrl
       const publicUrl = window.publicUrlstatic || window.publicUrl || '';
       const publicUrlapi = window.publicUrlapi || window.publicUrl || '';
       if((publicUrl || publicUrlapi) && href.indexOf(window.location.origin) === 0 && target.target === "blank"){
         e?.stopPropagation?.();
         e?.preventDefault?.();
         let targetHref = href.replace(window.location.origin, "");
         targetHref = getSecondPathUrl(targetHref);
         window.open(targetHref);
         return;
       } 
      // 处理域名白名单
      if (checkWhiteList(href)) return;
      // 设置"不再提醒"
      if (noRemind()) return;
      // 处理跨域地址
      if (isCorsOrigin(href)) {
        e?.stopPropagation?.();
        e?.preventDefault?.();
        if (ua.device === 'PC' && window.weappUi?.Dialog?.confirm) {
          window.weappUi.Dialog.confirm({
            mask: true,
            content: <Content />,
            onOk: () => {
              // weappSDK.openLink({ url: href });
              window.open(href, aTarget.target);
            },
          });
        } else if (ua.device !== 'pc' && window.weappUi?.MDialog?.prompt) {
          window.weappUi.MDialog.prompt({
            mask: true,
            message: <Content /> ,
            prompt: false,
            onOk: () => {
              // weappSDK.openLink({ url: href });
              window.open(href, aTarget.target);
            }
          });
        } else {
          // weappSDK.openLink({ url: href });
          window.open(href, aTarget.target);
        }
        return;
      }

      // 解析地址中的参数
      const { module, id, params } = formatUrl(href);
      // 处理事项卡片打开
      if (module && id) {
        e?.stopPropagation?.();
        e?.preventDefault?.();
        const currRootPath = (window.location.pathname || '').replace(/\/$/, () => '');
        const isMobile = ua.device === 'Mobile';
        if (isMobile) {
          const modulePath = moduleRouter.getModulePath(module);
          if (modulePath) {
            const { detailPath, mDetailPath } = modulePath;
            let singlePath = (isMobile ? mDetailPath : detailPath) || '';
            const idStr = moduleRouter.generateId(id, { params: params });
            singlePath = singlePath.replace('{id}', idStr);
            weappSDK.openLink({ url: singlePath });
          }
        } else {
          let currHistory = history;
          const rootPath = `${currRootPath}/_alink_`;
          const { routerRef, destroy } = showCorsRouter({ rootPath: rootPath });
          if (routerRef.current?.history) {
            currHistory = routerRef.current.history;
            const unlisten = currHistory.listen((location: any, action: any) => {
              if (action === 'POP' && location.pathname.indexOf(rootPath) === -1) {
                unlisten();
                destroy();
              }
            });
          }
          const path = moduleRouter.generateMoudelPath(module);
          const routePath = moduleRouter.generateRoute(path);
          const idStr = moduleRouter.generateId(id, { params: params });
          const subRoute = `${rootPath}${routePath}/${idStr}`;
          currHistory.push(subRoute);
        }
      }
    }
  }
}

new ALink();

export default ALink;

